import { Badge } from '@/components/ui/badge';
import { BadgeCheck, Star } from 'lucide-react';

export type AgencyTier = 'super_hot' | 'hot' | 'standard' | null | undefined;

interface Props {
  tier: AgencyTier;
  className?: string;
  size?: 'sm' | 'md';
}

/**
 * Agency-only package badge.
 * - super_hot → "Titanium" (gold)
 * - hot       → "Titanium" (gold, same label, slightly lower priority handled by sort)
 * - standard  → "Featured Agency" (primary)
 */
export function AgencyTierBadge({ tier, className = '', size = 'md' }: Props) {
  if (!tier) return null;

  const sizeCls = size === 'sm' ? 'text-[9px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5';

  if (tier === 'super_hot' || tier === 'hot') {
    return (
      <Badge
        className={`inline-flex items-center gap-1 font-bold uppercase tracking-wider border-0 bg-primary text-primary-foreground ${sizeCls} ${className}`}
      >
        <Star className="h-3 w-3 fill-current" />
        Titanium
      </Badge>
    );
  }

  // standard
  return (
    <Badge className={`inline-flex items-center gap-1 font-bold uppercase tracking-wide bg-primary text-primary-foreground ${sizeCls} ${className}`}>
      <BadgeCheck className="h-3 w-3" />
      Featured
    </Badge>
  );
}
